import {
  BookOpen,
  Calendar,
  ExternalLink,
  FileText,
  Globe,
  Link as LinkIcon,
  Mail,
  MapPin,
  Phone,
  ShoppingCart,
  Video,
} from "lucide-react";
import type { ComponentType, CSSProperties } from "react";

/** Maps an InfoLink `icon` key to a Lucide component. Falls back to ExternalLink. */
export const LINK_ICON_MAP: Record<
  string,
  ComponentType<{ size?: string | number; style?: CSSProperties; className?: string }>
> = {
  globe: Globe,
  "shopping-cart": ShoppingCart,
  "file-text": FileText,
  phone: Phone,
  mail: Mail,
  "map-pin": MapPin,
  calendar: Calendar,
  video: Video,
  book: BookOpen,
  link: LinkIcon,
  "external-link": ExternalLink,
};

/** Only allow http(s) and same-origin relative links to be rendered/opened. */
export const isSafeUrl = (url: string): boolean => {
  if (url.startsWith("/")) return true;
  try {
    const parsed = new URL(url);
    return parsed.protocol === "http:" || parsed.protocol === "https:";
  } catch {
    return false;
  }
};
